import * as z from 'zod';

export const emailNativeSchema = z.email();

export function emailSchema(optional = true) {
  return z.string().refine((v) => (optional && v?.trim() === '' ? true : emailNativeSchema.safeParse(v).success), {
    error: 'Invalid Email Address',
  });
}
